<template>
  <div id="app">
    <ChuangHeader/>
    <ChuangIntroduction/>
    <ChuangManagement />
    <ChuangCompetitive />
    <ChuangCore />
    <ChuangPersonnel />
    <ChuangFooter />
    <PopModal /> 
  </div>
</template>

<script>
import ChuangHeader from './components/ChuangHeader'
import ChuangIntroduction from './components/ChuangIntroduction'
import ChuangManagement from './components/ChuangManagement'
import ChuangCompetitive from './components/ChuangCompetitive'
import ChuangCore from './components/ChuangCore'
import ChuangPersonnel from './components/ChuangPersonnel'
import ChuangFooter from './components/ChuangFooter'
import PopModal from './components/PopModal'
export default {
  name: 'app',
  components: {
    ChuangHeader,
    ChuangIntroduction,
    ChuangManagement,
    ChuangCompetitive,
    ChuangCore,   
    ChuangPersonnel,
    ChuangFooter,
    PopModal,
  },
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/App.vue